<template>
  <base-info-card title="Shippers">
    <a
      :text="'Sign Up'"
      class="mb-8 grey--text body-1 d-block text-none"
      href="#"
      v-html="'&rsaquo; Sign Up'"
    />
    <a
      :text="'Terms & Condition'"
      class="mb-8 grey--text body-1 d-block text-none"
      href="#"
      v-html="'&rsaquo; Terms & Condition'"
    />
    <a
      :text="'Pricing'"
      class="mb-8 grey--text body-1 d-block text-none"
      href="#"
      v-html="'&rsaquo; Pricing'"
    />
    <a
      :text="'Reach Us'"
      class="mb-8 grey--text body-1 d-block text-none"
      href="#"
      v-html="'&rsaquo; Pricing'"
    />
  </base-info-card>
</template>

<script>
export default {
  name: "SectionFeaturesAlt",

  data: () => ({
    features: [
      "Zero Installation",
      "Easy Customization",
      "User Friendly Design",
      "24/7 Support Desk",
      "SEO Optimized",
    ],
  }),
};
</script>
